import { call, put, select } from "redux-saga/effects";
import { reviewApi } from "@services/api";
import { getAllReviewsUserActions } from "../slices";
import { showFailureToast } from "@helpers";

function* getAllReviewsUserWorker() {
  try {
    yield put(getAllReviewsUserActions.pending());
    const response = yield call(reviewApi.getAllReviewsUser, {});
    yield put(getAllReviewsUserActions.success(response));
    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(getAllReviewsUserActions.failure(error));
    // TODO: handle callback | onFailure
  }
}

function* getMoreReviewsUserWorker() {
  try {
    const { CurrentPage = 0 } = yield select(
      (state) => state.review.getAllReviewsUser.pagination
    );
    const response = yield call(reviewApi.getAllReviewsUser, {
      pageNumber: CurrentPage + 1,
    });
    yield put(getAllReviewsUserActions.getMoreSuccess(response));
    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(getAllReviewsUserActions.failure(error));
    // TODO: handle callback | onFailure
    yield call(showFailureToast, "Loading reviews failed!");
  }
}

export { getAllReviewsUserWorker, getMoreReviewsUserWorker };
